import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { iconSize, matIcons } from '../../../core/constants/constants';
import { AuthService } from '../../../core/services/auth.service';
import { IconService } from '../../services/icon.service';

@Component({
  selector: 'app-icons-picker',
  templateUrl: './icons-picker.component.html',
  styleUrls: ['./icons-picker.component.scss']
})
export class IconsPickerComponent implements OnInit {

  @Output()
  public onIconSearchOpen: EventEmitter<any> = new EventEmitter()

  @Input()
  public value: string = '';

  @Input()
  public formGroupNameValue: string = '';

  @Input()
  public state: any

  @Input()
  public isIconInputsShown = false;

  @Input()
  public form: any;

  @Input()
  public colorPickerPosition: any;

  @Input()
  title: string = 'Icon';

  public originalMatIcons = matIcons;

  public customIcons: {name: string, environment: string}[] = [];

  public iconSize = iconSize;

  public childForm: any;

  public get formRawValue() {
    return this.childForm?.getRawValue();
  }

  constructor(
    private parentFormGroup: FormGroupDirective,
    private authService: AuthService,
    private iconService: IconService
  ) { }

  ngOnInit() {
    this.originalMatIcons = [...this.originalMatIcons, ...this.iconService.getCustomIconsList(this.authService.userData.clientName)].sort().filter((icon) => {
      const isCustomIcon = this.customIcons.find((i) => icon === i.name);
      if (isCustomIcon) {
        return isCustomIcon.environment === this.authService.userData.clientName;
      } else {
        return true;
      }
    });

    if (this.form && this.formGroupNameValue) {
      this.childForm = this.form.get(this.formGroupNameValue);
    } else if (this.formGroupNameValue) {
      this.childForm = this.parentFormGroup.control.get(this.formGroupNameValue) as FormGroup;
    } else {
      if (this.form) {
        this.childForm = this.form;
      } else {
        this.childForm = this.parentFormGroup.form;
      }
    }
  }

  idTrackFn = (item: any) => item;

  iconExists(item: any) {
    const iconList = this.iconService.getCustomIconsList(this.authService.userData.clientName);
    return iconList?.find(icon => icon === item)
  }

  showIconInputs() {
    this.onIconSearchOpen.emit()
    this.isIconInputsShown = true;
  }

  public clearValue() {
    (this.childForm as FormControl).get('iconName')?.setValue('');
  }

  public getFilteredArray(): string[] {
    return this.originalMatIcons.filter(icon => icon.includes((this.childForm as FormControl).get('iconName')?.value))
  }

  public selectCurrentIcon(icon: string) {
    (this.childForm as FormControl).get('iconName')?.setValue(icon);
    this.childForm.markAsDirty();
  }

  public removeIcon() {
    (this.childForm as FormControl).get('iconName')?.setValue('');
    (this.childForm as FormControl).get('iconSize')?.reset();
    (this.childForm as FormControl).get('iconColor')?.reset();
  }

}
